import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  viewBox: "17 7 59 58",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("rect", {
      x: "29.5",
      y: "21.6",
      width: "33.3",
      height: "4.6",
      fill: "#00345b"
    }, null, -1),
    _createElementVNode("path", {
      fill: "#00345b",
      d: "M60.5,29.5h-28.6c-3.6,0-6.5,2.9-6.5,6.5s2.9,6.5,6.5,6.5v-4.6c-1.1,0-1.9-.9-1.9-1.9s.9-1.9,1.9-1.9h28.6c1.1,0,1.9.9,1.9,1.9s-.9,1.9-1.9,1.9v4.6c3.6,0,6.5-2.9,6.5-6.5s-2.9-6.5-6.5-6.5Z"
    }, null, -1),
    _createElementVNode("path", {
      fill: "#00345b",
      d: "M46.2,7.8c-15.5,0-28.2,12.6-28.2,28.2s12.6,28.2,28.2,28.2,28.2-12.6,28.2-28.2S61.7,7.8,46.2,7.8ZM57.3,57.3v-19.4h-4.6v21.2c-1.3.4-2.7.6-4.1.8v-22h-4.6v22c-1.4-.1-2.8-.4-4.1-.8v-21.2h-4.6v19.4c-7.7-4-12.9-12.1-12.9-21.3,0-13.2,10.8-24,24-24s24,10.8,24,24-5.3,17.3-12.9,21.3Z"
    }, null, -1)
  ])))
}
export default { render: render }